export const initials = (name: string) => name.split(' ').map((part) => part[0] ?? '').join('').slice(0, 2);
